<template>
  <div class="login login--contrast">
    <div class="container">
      <div class="row row-lg-right row-xl-right">
        <div class="col col-xs-12 col-md-8 col-lg-6">
          <div class="login__text">
            {{ glueUpPrepositions(registrationWarning) }}
          </div>
        </div>
        <div class="col col-xs-12 col-md-6 col-lg-4 col-lg-6">
          <div class="login__card">
            <el-card class="box-card" :body-style="{ padding: '40px 36px' }">
              <h1 class="login__title">
                Sign up to AllTeams
              </h1>
              <div class="login__no-account">
                Already a member?
                <router-link :to="{ name: 'Login' }">
                  <el-link>Sign in</el-link>
                </router-link>
              </div>

              <external-login />

              <el-divider content-position="center">or</el-divider>

              <div class="login__form">
                <el-form
                  @submit.native.prevent="validateForm"
                  label-width="0"
                  :rules="registerFormRules"
                  :model="registerForm"
                  ref="registerForm"
                >
                  <el-form-item
                    :error="errors.emailAddress"
                    prop="emailAddress"
                  >
                    <el-input
                      v-model="registerForm.emailAddress"
                      placeholder="Email"
                    />
                  </el-form-item>

                  <el-form-item :error="errors.message" prop="message">
                    <el-input
                      type="textarea"
                      :rows="3"
                      v-model="registerForm.message"
                      placeholder="Message"
                    />
                  </el-form-item>

                  <el-button
                    type="primary"
                    native-type="submit"
                    class="login__submit-button"
                    :disabled="isButtonDisabled('createAccount')"
                  >
                    Create account
                  </el-button>

                  <div class="login__privacy-confirm">
                    Filling this form, you confirm you agree with our
                    <el-link type="primary">
                      <router-link :to="{ name: 'PrivacyPolicy' }" type="primary">
                        privacy policy</router-link
                      >
                    </el-link>
                    and
                    <el-link type="primary">
                      <router-link :to="{ name: 'PersonalDataDeletion' }" type="primary">
                        data deletion policy</router-link
                      > </el-link
                    >.
                  </div>
                </el-form>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/common/Icon.vue';
import ExternalLogin from '@/components/unregisteredUsersPages/ExternalLogin.vue';

import { wantToRegisterInTavern } from '@/api/user.js';
import { disableButton } from '@/mixins/disableButton.js';
import { showMessage } from '@/utils/messages.js';
import { parseErrorsByFields, glueUpPrepositions } from '@/utils/index.js';

export default {
  name: 'WantToRegister',
  components: {
    Icon,
    ExternalLogin,
  },
  mixins: [disableButton],
  data() {
    return {
      registerForm: {
        emailAddress: '',
        message: '',
      },
      errors: {
        emailAddress: '',
        message: '',
      },
      registerFormRules: {
        emailAddress: [
          {
            required: true,
            trigger: 'input',
            message: 'Please input your email',
          },
        ],
        message: [{ required: false, trigger: '', message: '' }],
      },
      registrationWarning: `We are currently in the beta testing stage and membership at this moment is by invitation only. If you'd like to take part in testing please fill the form. Thank you and see you on our site!`,
    };
  },
  computed: {
    isFormFilled() {
      const { registerForm } = this;
      return Object.keys(registerForm).every(
        (key) => key === 'message' || registerForm[key] !== '',
      );
    },
  },
  methods: {
    showMessage,
    parseErrorsByFields,
    glueUpPrepositions,
    async requestCreateAccount() {
      this.disableButton('createAccount');
      const { emailAddress, message } = this.registerForm;

      const { success, errors } = await wantToRegisterInTavern({
        emailAddress,
        message: message.trim(),
      });
      this.enableButton('createAccount');

      if (errors) {
        this.errors = { ...this.errors, ...this.parseErrorsByFields(errors) };
      } else if (success) {
        this.showMessage({
          type: 'success',
          message:
            'Thank you for your trust! We will consider your application and inform you by email.',
        });
        this.clearForm();
        this.clearErrors();
      }
    },
    validateForm() {
      const { registerForm, isFormFilled } = this;

      if (this.$refs.registerForm) {
        this.$refs.registerForm.validate();
      }

      if (isFormFilled) {
        this.requestCreateAccount();
      } else {
        this.showMessage({
          type: 'error',
          message: 'Please enter your email',
        });
      }
    },
    clearForm() {
      const { registerForm } = this;
      for (const fieldName in registerForm) {
        registerForm[fieldName] = '';
      }
    },
    clearErrors() {
      for (const fieldName in this.errors) {
        this.errors[fieldName] = '';
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@/styles/shared/_globals.scss';
</style>
